import React from 'react';

const CorePrinciples = () => {
  return (
    <section className="core-principles">
      <h1 className="core-principles__title">3 Core Principles of CTDP</h1>
      <ol className="core-principles__list">
        <li>Sacred Seat Principle</li>
        <li>Mandatory Clause Principle</li>
        <li>Linear Time-Delay Principle</li>
      </ol>
    </section>
  );
};

export default CorePrinciples;
